<template>
  <div class="proDetails">
		<div class="main-banner" :style="'background-image: url('+bannerList+');'">
		</div>
		<div class="main">
			<div class="container">
				<div class="title">
					<h2>{{$AppLang == 'en' ? productData.titleEn : productData.title}}</h2>
					<!-- <p>{{$AppLang == 'en' ? productData.detailsEn : productData.details}}</p> -->
				</div>
				<div class="details">
					<div class="left wow fadeInUp" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
						<swiper class="myProList" :options="proListOptions">
							<swiper-slide v-for="item in productData.picList" :key="item.id">
								<img :src="item" alt="">
							</swiper-slide>
							<div class="proList-pagination" slot="pagination"></div>
						</swiper>
					</div>
					<div class="right wow fadeInRight" data-wow-duration="1s" data-wow-delay=".5s" data-wow-offset="20">
						<div v-html="$AppLang == 'en' ? productData.detailsEn : productData.details"></div>
						<span>{{$t('parameter')}}</span>
						<p v-for="item in productData.parameter" >{{item.specs}}：{{item.content}}</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
  export default {
  	name: 'proDetails',
  	data() {
  		return {
				productData:{},
				bannerList: [],
				proListOptions:{
					loop: true,
					pagination:{
						el: '.proList-pagination',
						clickable: true,
					},

				}
  		};
  	},
		mounted() {
			this.bannerApi();
		},
		created() {
			var that = this;
      var options={ live:false};
			var goodsId = '';
			goodsId = this.$route.query.goodsId;

			that.$api.post(
				'/goods/goodsInfo',
				{
					goodsId: goodsId
				},
				function(res) {
					if(res.data.rtnCode == 200){
						var list = res.data.data;
						that.productData = list;
						that.productData.picList = JSON.parse(that.productData.pic);
						if(that.$AppLang == 'en'){
							that.productData.parameter = JSON.parse(that.productData.contentEn);
						}else{
							that.productData.parameter = JSON.parse(that.productData.content);
						}
            that.$nextTick(function(){
            	var wow=new that.$wow.WOW(options).init();
            });
					}else{
						alert(res.data.msg);
					}
				}
			);
		},
		methods:{
			bannerApi(){
				var that = this;
				//banner请求接口
				that.$api.post(
					'banner/websiteBanners',
					{
						type: 2
					},
					function(res) {
						if(res.data.rtnCode == 200){
							var list = res.data.data;
							for(var i=0;i<list.length;i++){
								if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))){
									list[i].banner = list[i].phone_banner;
								}else{
									list[i].banner = list[i].pic;
								}
							}
							that.bannerList = list[0].banner;
						}else{
							alert(res.data.msg);
						}

					}
				);
			}
		},
    metaInfo: {
      title: '佛山鼎吉-产品详情', // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: '鼎吉,鼎吉官网,陶瓷墙地砖拣选包装自动化设备,研发、设计、制造、安装为一体的高新技术型企业,佛山市鼎吉包装技术有限公司'
      },
      { // set meta
        name: 'description',
        content: '佛山市鼎吉包装技术有限公司成立于2008年,是一家集研发、设计、制造、安装为一体的高新技术型企业。专业致力于研发生产陶瓷墙地砖拣选包装自动化设备。公司遵循“以市场为导向、以研发为动力、以质量为核心竞争力”的发展宗旨服务建陶企业，为建陶产业的生产自动化和可持续发展做贡献。'
      }],
      link: [{ // set link
        rel: 'asstes',
        href: 'https://www.dinovor.com/'
      }]
    }
  }
</script>

<style>
.proDetails{
	background: #FFFFFF;
	padding-bottom: 50px;
}
.proDetails .main-banner{
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
}
.proDetails .main{
	padding-top: 50px;
}
.proDetails .title{
	margin-bottom: 50px;
	padding-bottom: 50px;
	border-bottom: 1px dashed #aeaeae;
}
.proDetails .title h2{
	margin-bottom: 20px;
	font-size: 20px;
	text-align: center;
}
.proDetails .title p{
	font-size: 12px;
	color: #666666;
	text-align: center;
	line-height: 20px;
}
.details{
	display: flex;
	justify-content: space-between;
  flex-wrap: wrap;
}
.details .left{
	width: 50%;
}
.details .right{
	width: 50%;
	padding-left: 5%;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.details .right span{
	margin-bottom: 20px;
}
.details .right p{
	margin-bottom: 10px;
	font-size: 14px;
}
.proDetails .swiper-container-horizontal > .swiper-pagination-bullets{
	position: absolute;
	z-index: 2;
}
.proDetails .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet-active{
	background: rgba(0,0,0,.6);
}
@media (max-width: 992px){
  .details .left,.details .right{
    width: 100%;
  }
  .details .right{
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product/pro-details.vue